import { EVENTS_CLOSE_ACTION_ENABLE_MODAL } from './constants';

export function closeActionEnableModal() {
  return {
    type: EVENTS_CLOSE_ACTION_ENABLE_MODAL,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_CLOSE_ACTION_ENABLE_MODAL:
      return {
        ...state,
        isOpenActionEnableModal: false,
      };

    default:
      return state;
  }
}
